var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCircleChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 6.99992C0.333008 3.31802 3.31777 0.333252 6.99967 0.333252C10.6815 0.333252 13.6663 3.31802 13.6663 6.99992C13.6663 10.6818 10.6815 13.6666 6.99967 13.6666C3.31777 13.6666 0.333008 10.6818 0.333008 6.99992ZM9.71667 4.28804C10.0178 4.49994 10.0901 4.9158 9.87821 5.21691L6.71154 9.71692C6.59507 9.88239 6.40981 9.98605 6.20787 9.99865C6.00587 10.0113 5.80914 9.93145 5.67307 9.78172L4.00638 7.94838C3.75871 7.67592 3.77879 7.25432 4.05123 7.00665C4.32366 6.75899 4.74529 6.77905 4.99297 7.05145L6.09994 8.26919L8.78781 4.44959C8.99967 4.14848 9.41554 4.07616 9.71667 4.28804Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCircleChecked);
export default __webpack_public_path__ + "static/media/blackCircleChecked.1ac61618662e7ff76ed71a4e7419268d.svg";
export { ForwardRef as ReactComponent };